import { ref, watch } from "vue";
export default {
  props: ["title", "isShowLeft", 'backgroundColor', 'color'],
  setup(props, context) {
    const list = ref([]); // 导航栏列表
    const activeKey = ref(''); // 当前激活nav栏高亮显示标题的下标

    watch(() => props.navLists, newVal => {
      list.value = newVal;
    }, {
      deep: true,
      immediate: true
    });
    watch(() => props.defaultActive, newVal => {
      activeKey.value = newVal;
    }, {
      deep: true,
      immediate: true
    });
    const backClick = () => {
      // 点击返回按钮触发的事件
      props.isShowLeft && context.emit('backClick');
    };
    return {
      list,
      activeKey,
      backClick
    };
  }
};